import { render, staticRenderFns } from "./OrderAddressSelect.vue?vue&type=template&id=ad556c44&"
import script from "./OrderAddressSelect.vue?vue&type=script&lang=js&"
export * from "./OrderAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports